<template>
  <header>
    <a href="http://liveperformance.com.au" target="_blank" title="Live Performance Australia" class="lpalogo">Live
      Performance Australia</a>

    <div class="row clearfix">
      <page-title text="LPA 2019 and 2020 Ticket Attendance and Revenue Report"></page-title>
      <NavMenu/>
    </div>
    <div class="fullbg">
      <p class="caption">Photo: <em>West Side Story Handa Opera on Sydney Harbour</em>, Opera Australia, Photo Credit: Prudence Upton</p>
      <div class="overlay"></div>
    </div>
  </header>
</template>

<script>
import PageTitle from '@/components/atoms/PageTitle'

export default {
  components: {
    PageTitle
  }
}
</script>
